var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"container txt-16",attrs:{"direction":"vertical"}},[_c('Header'),_c('el-main',{staticClass:"main"},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }